import { render, staticRenderFns } from "./PosReceiptForm.vue?vue&type=template&id=10f15bbe&"
import script from "./PosReceiptForm.vue?vue&type=script&lang=js&"
export * from "./PosReceiptForm.vue?vue&type=script&lang=js&"
import style0 from "./PosReceiptForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports